/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PowerConsumption } from "./PowerConsumption";
import {
    PowerConsumptionFromJSON,
    PowerConsumptionFromJSONTyped,
    PowerConsumptionToJSON,
} from "./PowerConsumption";

/**
 *
 * @export
 * @interface PowerConsumptionResponse
 */
export interface PowerConsumptionResponse {
    /**
     * PowerMeterValues averaged over the requested interval
     * @type {Array<PowerConsumption>}
     * @memberof PowerConsumptionResponse
     */
    items?: Array<PowerConsumption>;
    /**
     * Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings
     * @type {string}
     * @memberof PowerConsumptionResponse
     */
    siteTimeZone?: string;
    /**
     * The PowerMeter id
     * @type {string}
     * @memberof PowerConsumptionResponse
     */
    deviceIdentity?: string;
    /**
     * The switchboard this powermeter is associated with.
     * @type {string}
     * @memberof PowerConsumptionResponse
     */
    switchboardId?: string;
    /**
     * The max capacity of this switchboard on L1.
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardMaxCapacityL1Amps?: number;
    /**
     * The max capacity of this switchboard on L2.
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardMaxCapacityL2Amps?: number;
    /**
     * The max capacity of this switchboard on L3.
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardMaxCapacityL3Amps?: number;
    /**
     * The capacity buffer of this switchboard on L1.
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardBufferL1?: number;
    /**
     * The capacity buffer of this switchboard on L2.
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardBufferL2?: number;
    /**
     * The capacity buffer of this switchboard on L3.
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardBufferL3?: number;
    /**
     * The current rating of this switchboard, to graph EVDB capacity
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardLoadLimitA?: number;
    /**
     * The physical capacity of this switchboard.
     * @type {number}
     * @memberof PowerConsumptionResponse
     */
    switchboardCapacityA?: number;
}

/**
 * Check if a given object implements the PowerConsumptionResponse interface.
 */
export function instanceOfPowerConsumptionResponse(
    value: object,
): value is PowerConsumptionResponse {
    return true;
}

export function PowerConsumptionResponseFromJSON(
    json: any,
): PowerConsumptionResponse {
    return PowerConsumptionResponseFromJSONTyped(json, false);
}

export function PowerConsumptionResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PowerConsumptionResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(PowerConsumptionFromJSON),
        siteTimeZone:
            json["siteTimeZone"] == null ? undefined : json["siteTimeZone"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        switchboardId:
            json["switchboardId"] == null ? undefined : json["switchboardId"],
        switchboardMaxCapacityL1Amps:
            json["switchboardMaxCapacityL1Amps"] == null
                ? undefined
                : json["switchboardMaxCapacityL1Amps"],
        switchboardMaxCapacityL2Amps:
            json["switchboardMaxCapacityL2Amps"] == null
                ? undefined
                : json["switchboardMaxCapacityL2Amps"],
        switchboardMaxCapacityL3Amps:
            json["switchboardMaxCapacityL3Amps"] == null
                ? undefined
                : json["switchboardMaxCapacityL3Amps"],
        switchboardBufferL1:
            json["switchboardBufferL1"] == null
                ? undefined
                : json["switchboardBufferL1"],
        switchboardBufferL2:
            json["switchboardBufferL2"] == null
                ? undefined
                : json["switchboardBufferL2"],
        switchboardBufferL3:
            json["switchboardBufferL3"] == null
                ? undefined
                : json["switchboardBufferL3"],
        switchboardLoadLimitA:
            json["switchboardLoadLimitA"] == null
                ? undefined
                : json["switchboardLoadLimitA"],
        switchboardCapacityA:
            json["switchboardCapacityA"] == null
                ? undefined
                : json["switchboardCapacityA"],
    };
}

export function PowerConsumptionResponseToJSON(
    value?: PowerConsumptionResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(PowerConsumptionToJSON),
        siteTimeZone: value["siteTimeZone"],
        deviceIdentity: value["deviceIdentity"],
        switchboardId: value["switchboardId"],
        switchboardMaxCapacityL1Amps: value["switchboardMaxCapacityL1Amps"],
        switchboardMaxCapacityL2Amps: value["switchboardMaxCapacityL2Amps"],
        switchboardMaxCapacityL3Amps: value["switchboardMaxCapacityL3Amps"],
        switchboardBufferL1: value["switchboardBufferL1"],
        switchboardBufferL2: value["switchboardBufferL2"],
        switchboardBufferL3: value["switchboardBufferL3"],
        switchboardLoadLimitA: value["switchboardLoadLimitA"],
        switchboardCapacityA: value["switchboardCapacityA"],
    };
}
